import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1F3A] text-white" data-testid="main-footer">
      {/* CTA Section */}
      <div className="container-premium py-20 lg:py-28">
        <div className="max-w-4xl">
          <p className="overline text-[#6FAE3A] mb-4">Ready to Build Your Legacy?</p>
          <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6">
            Building Leaders.<br />
            <span className="text-[#6FAE3A]">Creating Legacy.</span>
          </h2>
          <p className="text-slate-300 text-lg lg:text-xl leading-relaxed mb-10 max-w-2xl">
            Partner with Legacy Leadership Group to strengthen leadership capacity, improve organizational systems, and create measurable results that continue long after the engagement ends.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact" data-testid="footer-cta-primary">
              <Button className="bg-[#4F8A2F] hover:bg-[#6FAE3A] text-white rounded-full px-8 py-4 font-body font-semibold transition-all duration-300 hover:-translate-y-0.5">
                Partner With Us
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/programs" data-testid="footer-cta-secondary">
              <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 rounded-full px-8 py-4 font-body">
                Explore Our Services
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Links */}
      <div className="border-t border-white/10">
        <div className="container-premium py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              <h3 className="font-display text-2xl font-bold mb-4">
                Legacy Leadership Group
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-md">
                A district transformation partner helping school systems build leadership, strengthen organizational systems, and produce results that last.
              </p>
              <p className="text-xs text-slate-500">
                Owned and Operated by Captain Cameron Whitlow Enterprises LLC
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-body text-sm font-semibold uppercase tracking-wider text-[#4F8A2F] mb-6">
                Quick Links
              </h4>
              <nav className="flex flex-col gap-3">
                <Link to="/about" className="text-slate-300 hover:text-white text-sm transition-colors">About</Link>
                <Link to="/programs" className="text-slate-300 hover:text-white text-sm transition-colors">Signature Programs</Link>
                <Link to="/accelerator" className="text-slate-300 hover:text-white text-sm transition-colors">District Accelerator</Link>
                <Link to="/book" className="text-slate-300 hover:text-white text-sm transition-colors">Book Cameron</Link>
                <Link to="/contact" className="text-slate-300 hover:text-white text-sm transition-colors">Contact</Link>
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-body text-sm font-semibold uppercase tracking-wider text-[#4F8A2F] mb-6">
                Connect
              </h4>
              <div className="space-y-4">
                <a 
                  href="mailto:legacyleadersgroupal@gmail.com" 
                  className="flex items-center gap-3 text-slate-300 hover:text-white text-sm transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  legacyleadersgroupal@gmail.com
                </a>
                <a 
                  href="tel:256-657-8429" 
                  className="flex items-center gap-3 text-slate-300 hover:text-white text-sm transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  (256) 657-8429
                </a>
                <a 
                  href="https://www.linkedin.com/in/cameron-whitlow-66a7ba185" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-300 hover:text-white text-sm transition-colors"
                >
                  <Linkedin className="w-4 h-4" />
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10">
          <div className="container-premium py-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-xs">
              &copy; {currentYear} Legacy Leadership Group. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs">
              Building Leaders. Creating Legacy.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
